import { getSvgIcon, InterfaceIcon } from '@helpers/icons';
import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import { useReducedMotion } from 'framer-motion';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useFirstMountState, useMedia } from 'react-use';
import S from './MembershipCard.styles';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
const MembershipCard = (props) => {
    const isFirstMount = useFirstMountState();
    const mobileLayout = useMedia(until(Device.TabletLarge));
    const shouldReduceMotion = useReducedMotion();
    const idString = props.title.replace(/\s+/g, '-').toLowerCase();
    const btnRef = React.useRef(null);
    React.useEffect(() => {
        if (props.focusId === props.thisId) {
            btnRef.current?.focus();
        }
    }, [props.focusId]);
    // Scroll to active question
    React.useEffect(() => {
        if (isFirstMount) {
            return;
        }
        setTimeout(() => {
            if (props.currentActive !== props.thisId) {
                return;
            }
            btnRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 350);
    }, [props.currentActive]);
    return (React.createElement(S.CardWrapper, null,
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.AccordionBtn, { type: "button", ref: btnRef, id: `${idString}-accordion`, "aria-expanded": props.thisId === props.currentActive, "aria-controls": `${idString}-accordion-content`, onClick: (e) => {
                    e.preventDefault();
                    props.setIsActive && props.setIsActive();
                }, onFocus: () => props.setFocusId && props.setFocusId(props.thisId ?? undefined), onKeyDown: (event) => {
                    const id = props.thisId === undefined ? 0 : props.thisId;
                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault();
                            event.stopPropagation();
                            props.setFocusId &&
                                props.setFocusId(props.totalLength && props.focusId !== props.totalLength - 1 ? id + 1 : 0);
                            break;
                        case 'ArrowUp':
                            event.preventDefault();
                            event.stopPropagation();
                            props.setFocusId &&
                                props.setFocusId(props.totalLength && props.focusId === 0
                                    ? props.totalLength - 1
                                    : props.thisId && props.thisId - 1);
                            break;
                        case 'Home':
                            event.preventDefault();
                            event.stopPropagation();
                            props.setFocusId && props.setFocusId(0);
                            break;
                        case 'End':
                            event.preventDefault();
                            event.stopPropagation();
                            props.setFocusId && props.setFocusId(props.totalLength && props.totalLength - 1);
                            break;
                        default:
                            break;
                    }
                }, "data-active": props.thisId === props.currentActive },
                props.tabIcon && React.createElement(S.AccordionIcon, null, getSvgIcon(props.tabIcon)),
                React.createElement(S.AccordionTitle, null, props.title),
                React.createElement(S.ChevronIcon, null, getSvgIcon(InterfaceIcon.Chevron)))),
        React.createElement(S.AccordionContent, { animate: mobileLayout ? (props.currentActive === props.thisId ? 'open' : 'closed') : 'open', initial: mobileLayout ? (props.currentActive === props.thisId ? 'open' : 'closed') : 'open', variants: {
                open: {
                    height: 'auto',
                },
                closed: {
                    height: 0,
                },
            }, transition: shouldReduceMotion ? { duration: 0 } : { ease: [0.45, 0.01, 0.1, 1] }, role: "region", "aria-labelledby": `${idString}-accordion`, id: `${idString}-accordion-content` },
            React.createElement(S.Container, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.ContentGrid, null,
                    props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
                    props.list && props.list.length > 0 && (React.createElement(S.List, null, props.list.map((item) => (React.createElement(S.ListItem, { key: item.id },
                        React.createElement(S.ListIcon, null, getSvgIcon(item.icon)),
                        React.createElement(S.ListContent, { dangerouslySetInnerHTML: { __html: item.content } })))))),
                    props.cta && (React.createElement(S.CtaWrapper, null,
                        React.createElement(LinkButton, { href: props.cta.url, buttonType: props.cta.buttonType ?? 'primary', icon: props.cta.icon, iconOnly: false }, props.cta.text))))))));
};
export default withMotion(MembershipCard);
